/*
 * @Description: 自然人
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { accountManagement } from '@/api/ajax';
import fields from '../fields';
import search from '../search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let example = new TableRenderClass({ fields, search });
let part = example.createPart({
  name: '主账号管理',
  search: [],
  list: () => {
    return new Promise(async resolve => {
      const response = await accountManagement.masterAccountManagementList();
      const resData = {
        data: { data: { list: [response.pdata] } }
      };
      resolve(resData);
    });
  },
  defaultQuery: { allianceUserType: 1 },
  fields: [
    'index',
    'mainAccountName',
    'password',
    'authPeople',
    'authPeoplePhone',
    'lastLoginTime',
    'ip'
  ]
});

export default part;
